import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import Root from './root';
import { initTheme } from './store/themeStore';

// Apply persisted theme before first render to prevent flash
initTheme();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
